import type { TodoNoteWorkspaceSnapshot } from './todoNoteWorkspaceCache';

export const TODO_NOTE_WORKSPACE_SAVED_EVENT = 'cp:todo-note-workspace-saved';

export type TodoNoteWorkspaceSavedDetail = {
  userId: string;
  noteWorkspaceId: string | null;
  /** 있으면 추가 fetch 없이 캐시만 패치 */
  snapshot?: TodoNoteWorkspaceSnapshot;
  /** 저장된 공유 보드. 없으면 기본 보드로 취급 */
  boardId?: string;
};

export function emitTodoNoteWorkspaceSaved(detail: TodoNoteWorkspaceSavedDetail): void {
  if (typeof window === 'undefined') return;
  if (!detail.userId) return;
  window.dispatchEvent(new CustomEvent(TODO_NOTE_WORKSPACE_SAVED_EVENT, { detail }));
}
